<template>
  <!--    <mu-circular-progress :size="40" v-if="loading"/>-->

  <div :class="'hc ' + (type == 1 ? 'hc-dialog-page' : type == 3 ? 'hc-game-page' : 'hc-page')"
       v-if="showHtmlDialogWidget" ref="hcDialogPage">
    <div class="page-close" @click.stop="closeHC"></div>
    <div class="title-pointer" ref="gamePointer" @click.stop="closeGame" v-if="type==3" :style="{bottom:wrapHeight()}"></div>
    <iframe v-if="gameVisible" :src="url" frameborder="0" ref="hdDialogContent" id="hdIframeContent"
            :style="{height:wrapHeight()}"></iframe>
  </div>
</template>
<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .hc-dialog-page,
  .hc-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    pointer-events: all;
  }

  iframe {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70%;
    background: #fff;
    z-index: 5;
  }

  .hc-dialog-page iframe {
    height: 70%;
    .b-radius(24, 24, 0, 0);
  }

  .hc-game-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    pointer-events: all;

    .title-pointer {
      .w(310);
      .h(70);
      position: absolute;
      bottom: calc(100vw);
      background: url(../../assets/imgs/game/game_dialog_pointer.png) no-repeat;
      background-size: contain;
      margin-left: 50%;
      transform: translateX(-50%);
    }

  }

  .hc-game-page iframe {
    height: calc(100vw);
    .b-radius(24, 24, 0, 0);
  }

  .hc-page {
    z-index: 10;
    top: 0;
    position: fixed;
    background-color: #ffffff;

    iframe {
      height: calc(100% - 0.9rem);
      .b-radius(0);
    }

    .page-close {
      .w(48) !important;
      .h(48) !important;
      background: url(../../assets/imgs/page-close-btn.png) no-repeat;
      background-size: contain;
      .top(10) !important;
      cursor: pointer;
      float: right;
      z-index: 6;
      .left(30);
      position: fixed !important;
    }
  }

  ::-webkit-scrollbar {
    display: none !important;

  }

  ::-webkit-scrollbar-thumb {
    width: 0 !important;
    display: none !important;
  }
</style>
<script>

  import {hideDialog, isnull, localGet, localSave, showDialog} from "../../utils/tools";
  import global from "../../config/global";
  import router from "../../router";
  import {UserType} from "../../const/Tags";
  import EventBusConstant from "../../push/const/EventBusConstant";

  export default {
    // 使用时请使用 :url.sync=""传值
    props: {
      type: {
        required: true,
        default: 1
      },
      url: {
        required: true,
        default: '',
      },
      showHtmlDialogWidget: {
        required: true,
        default: false,
      },
      whRate: {
        default: 1
      }
    },
    data() {
      return {
        closeManual: false,
        pre: '',
        contentLoaded: false,
        loading: false,
        html: '',
        type: 1,//1-dialog 2-page,
        needToggleFullScreen: true,
        gameVisible: true,
      }
    },
    created() {

    },
    mounted() {

      // let ifa = document.getElementById('hdIframeContent')
      // let _this = this
      // if (!ifa.addEventListener) {
      //   ifa.attachEvent('onload', this.iframeLoad)
      // } else {
      //   ifa.addEventListener('load', this.iframeLoad)
      // }
      // // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容

    },
    watch: {
      showHtmlDialogWidget(n, o) {
        let target = this
        if (n) {
          this.needToggleFullScreen = true
          this.$nextTick(() => {
            window.addEventListener('message', this.handleMessage)

            // 告诉父组件准备好接收消息了
            window.parent.postMessage({
              cmd: 'ready-for-receiving'
            }, '*')
          })
          if (this.pre == this.url) {
            this.contentLoaded = true
          } else {
            this.contentLoaded = this.type != 3
            this.gameVisible = false
            this.$nextTick(() => {
              this.gameVisible = true
            })
            // showDialog(this)
          }
          setTimeout(() => {
            target.$refs.hcDialogPage.addEventListener('click', target.bodyCloseHtmlDialog)
          }, 200)
        } else {
          // target.toggleAudio(n)
          if (this.type == 2 && this.needToggleFullScreen)
            if (this.closeManual) {
              this.pre = ''
              $('iframe').html('')
            } else
              this.pre = this.url
          window.removeEventListener('message', this.handleMessage)
          this.contentLoaded = false
          this.$refs.hcDialogPage.removeEventListener('click', this.bodyCloseHtmlDialog)
        }
      },
      url(n, o) {
        if (!isnull(n) && this.pre != n) {
          this.$nextTick(() => {

          })
        }
      }

    },
    methods: {
      wrapHeight() {
        switch (this.type) {
          case 1:
            return '70%;'
          case 2:
            return 'calc(100% - 0.9rem)'
          case 3:
            return 'calc(100vw * '+this.whRate+')'
        }
      },
      toggleAudio(on) {
        if (this.$refs.hdDialogContent) {
          let childWindow = this.$refs.hdDialogContent.contentWindow
          if (on) {
            childWindow.GLOpenSound && childWindow.GLOpenSound()
          } else
            childWindow.GLOffSound && childWindow.GLOffSound()
        }
      },
      bindLoad() {
        const {hdDialogContent} = this.$refs;
        const that = this;
        if (hdDialogContent.attachEvent) {
          // IE
          hdDialogContent.attachEvent('onload', () => {
            that.iframeLoad();
          });
        } else {
          // 非IE
          hdDialogContent.onload = function () {
            that.iframeLoad();
          };
        }
      },
      iframeLoad() {
        console.log('iframe加载完成')
        hideDialog(this)
        // this.toggleAudio(true)
        this.contentLoaded = true
        this.$forceUpdate()
      },
      closeGame() {
        console.log('game click close')
        localSave(global.key.ACT_URL, '')
        this.closeManual = true
        this.hideHtmlDialogPage()
      },
      closeHC() {
        localSave(global.key.ACT_URL, '')
        this.hideHtmlDialogPage()
      },
      hideHtmlDialogPage() {
        this.$emit('hideHtmlDialogWidgetPage')
      },
      bodyCloseHtmlDialog(e) {
        let self = this;
        if (this.$refs.hdDialogContent && !this.$refs.hdDialogContent.contains(e.target)) {
          // if (self.type == 1||(self.type==3&&self.contentLoaded==false)) {
          if (self.type == 1) {
            self.closeManual = false
            self.hideHtmlDialogPage()
          }
        }
      },
      handleMessage(event) {
        // 根据上面制定的结构来解析 iframe 内部发回来的数据
        let data = event.data
        if (typeof data == 'string' && data[0] == '{' && data[data.length - 1] == '}')
          data = JSON.parse(data)
        switch (data.cmd) {
          case 'toRecharge':
            // 业务逻辑
            localSave(global.key.ACT_URL, this.src)
            this.$EventBus.$emit(EventBusConstant.EVENT_SHOW_RECHARGE_DIALOG)
            break
          case 'refreshCoins':
            // 业务逻辑
            global.setCoins(data.data)
            break
          case 'decreaseCoins':
            // 业务逻辑
            global.decreaseCoins(data.data)
            break
          case 'detail':
            // 业务逻辑
            if (!data.data)
              return
            if (data.type == UserType.ANCHOR) {
              localSave(global.key.ACT_URL, this.src)
              this.needToggleFullScreen = false
              this.closeHC()
              router.togo({
                name: 'AnchorInfoDetail',
                params: {
                  acc: data.data || "",
                }
              })

            }
            break
          case 'contentSize':
            // let contentSize = data.data
            // console.log('act',contentSize)
            // if (!isnull(contentSize) && contentSize.length > 1) {
            //   $('iframe').css({
            //     height: contentSize[1] + 'px',
            //   })
            //   $('iframe::-webkit-scrollbar').css({
            //     display: 'none'
            //   })
            // }
            break
          case 'loaded':
            // this.iframeLoad()
            break
          case 'ready-for-receiving':
            this.iframeLoad()
            break
        }
      },
      destroyed() {
        // 注意移除监听！注意移除监听！注意移除监听！

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widget/htmlpanel.vue